import { Router } from '@angular/router';
import * as pages from '../../core/routing/page-names';

export class UrlHelper {

  public static getIdForSegment(segmentName: string, router: Router): number {
    var segments = router.url.split('/');
    var id =  parseInt(segments[segments?.indexOf(segmentName) + 1]);
    return (id != null && id != undefined && !isNaN(id) && id != 0) ? id : null;
  }

  public static getTabSegmentForConfigurations(router: Router, configurationPageName: string): string {
    var segments = router.url.split('/');
    var tabSegment = segments[segments.indexOf(configurationPageName) + 2];
    return tabSegment;
  }

  public static getTabSegmentForResponseExportConfiguration(router: Router): string {
    var segments = router.url.split('/');
    var tabSegment = segments[segments.indexOf(pages.importConfigurationsResponsePageName) + 2];
    return tabSegment;
  }
}
